import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { OrganizationList } from '@verantos-dev/feature-organizations-list';

const APP_ID = EvidencePlatformSidebarAppID.organizations;

export const OrganizationsUiRoutes = () => {
  useAppId(APP_ID);
  return (
    <Routes>
      <Route index element={<OrganizationList />} />
    </Routes>
  );
};

export default withAuth(OrganizationsUiRoutes, APP_ID);
